// extracted by mini-css-extract-plugin
export default {"card":"NewOption_card__4eHb+"};